var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3333 3.33335H6.66663C4.82568 3.33335 3.33329 4.82574 3.33329 6.66669V13.3334C3.33329 15.1743 4.82568 16.6667 6.66663 16.6667H13.3333C15.1742 16.6667 16.6666 15.1743 16.6666 13.3334V6.66669C16.6666 4.82574 15.1742 3.33335 13.3333 3.33335ZM6.66663 1.66669C3.9052 1.66669 1.66663 3.90526 1.66663 6.66669V13.3334C1.66663 16.0948 3.9052 18.3334 6.66663 18.3334H13.3333C16.0947 18.3334 18.3333 16.0948 18.3333 13.3334V6.66669C18.3333 3.90526 16.0947 1.66669 13.3333 1.66669H6.66663Z",
    fill: "#777E91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 6.66667C14.627 6.66667 15 6.29357 15 5.83333C15 5.3731 14.627 5 14.1667 5C13.7065 5 13.3334 5.3731 13.3334 5.83333C13.3334 6.29357 13.7065 6.66667 14.1667 6.66667Z",
    fill: "#777E91"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1667 9.99998C14.1667 12.3011 12.3012 14.1666 10 14.1666C7.69886 14.1666 5.83337 12.3011 5.83337 9.99998C5.83337 7.6988 7.69886 5.83331 10 5.83331C12.3012 5.83331 14.1667 7.6988 14.1667 9.99998ZM12.5 9.99998C12.5 11.3807 11.3808 12.5 10 12.5C8.61929 12.5 7.50004 11.3807 7.50004 9.99998C7.50004 8.61923 8.61929 7.49998 10 7.49998C11.3808 7.49998 12.5 8.61923 12.5 9.99998Z",
    fill: "#777E91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.5b2484053e0376f202cd4e8e77fd4d5a.svg";
export { ForwardRef as ReactComponent };